import axios from "axios";

// Use relative URL to leverage Vite proxy
const API_BASE_URL = '/api/v1';

export const submitCustomerFeedback = async (feedbackData) => {
    try {
        const response = await axios.post(
            `${API_BASE_URL}/customer-feedback`,
            feedbackData,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error submitting feedback:", error);
        throw error.response?.data || error;
    }
};
// customerFeedbackService.js
export const getCustomerFeedback = async (sessionId) => {
  try {
    const response = await axios.get(
      `/api/v1/customer-feedback/session/${sessionId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching feedback:", error);
    throw error.response?.data || error;
  }
};

